export const createBreadCrumbsStructuredData = (
  crumbs: Array<{label: string; href: string}>,
) => {
  // 構造化データ https://developers.google.com/search/docs/appearance/structured-data/breadcrumb?hl=ja
  const HOST = 'https://gaishishukatsu.com';
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: crumbs.map((crumb, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.label,
        item: crumb.href ? HOST + crumb.href : '', // 絶対URL
      })),
    },
  ];
  return structuredData;
};
